import React, { Fragment, useEffect, useState } from "react";
import {
  getOrdersResultByOrderID,
  getOrdersResultForDoctor,
} from "@cabinet-packages/api";
import { setResultsByOrderId } from "@cabinet-packages/redux";
import {
  getCanShowFeedback,
  getOrdersResultByOrderIDIntegration, getOrdersResultByOrderIDIntegrationRaw,
  getResults,
  getResultsMedis,
  getResultsPdfIntegration,
} from "@cabinet-packages/api/api";
import {
  CabinetAccordion,
  CabinetAccordionDetails,
  CabinetAccordionSummary,
} from "../../settings/cabinetAccordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DownloadIcon from "@material-ui/icons/GetApp";
import Typography from "@material-ui/core/Typography";
import { getDateLabelPattern } from "../../utils/InputValuePatterns";
import AlarmTooltip from "../AlarmTooltip";
import { Rating } from "@material-ui/lab";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarIcon from "@material-ui/icons/Star";
import { Grid, makeStyles, useMediaQuery, Button } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomDialog,
  Loading,
  ResultJSON,
} from "@cabinet-packages/components";
// import RespondVisitDialog from "../DialogComponents/RespondVisitDialog";
// import AccordionDetailsTera from "./AccordionDetailsTera";

const useStyles = makeStyles((theme) => ({
  accordionRoot: {
    margin: "14px 0px !important",
  },
  summaryContainer: {
    display: "grid",
    gridGap: "10px",
    gridTemplateColumns: "2fr 1fr 2fr 1fr 1fr 1fr",
    width: "80%",
    alignItems: "end",
    "@media (max-width:1000px)": {
      gridTemplateColumns: "1fr",
      gridTemplateRows: "auto auto auto",
    },
  },
  columnLabel: {
    fontSize: "12px",
    color: theme.palette.grey.text,
    fontWeight: 500,
    "@media(max-width: 1000px)": {
      fontSize: "9px",
    },
  },
  summaryContent: {
    display: "grid",
    gridTemplateColumns: "100px 0.5fr 1.5fr 1.5fr 1fr",
    gap: "10px",
    height: "max-content",
    margin: "12px 0px !important",

    "@media(max-width: 1000px)": {
      display: "flex",
      flexWrap: "wrap",
      height: "max-content",
      rowGap: "5px",
    },
  },
  resultLabel: {
    fontWeight: 600,
    fontSize: "14px",
  },
  idNameContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",

    "@media(max-width: 1000px)": {
      flexDirection: "column",
      justifyContent: "space-evenly",
    },
  },
  researchLabel: {
    fontSize: "12px",
    wordBreak: "break-word",
  },
  researchLabelNorm: {
    fontSize: "11px",
    wordBreak: "break-word",
    marginLeft: "8px",
    fontStyle: "italic",
    textAlign: "end",
  },
  rateIconFilled: {
    color: theme.palette.colors.main,
  },
  rateIconHover: {
    transform: "scale(1)",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
    padding: "10px 10px",
    backgroundColor: "#F8F9F9",
    margin: "10px 0px",
    width: "100%",
  },
  researchDescription: {
    display: "flex",
    rowGap: "10px",
    padding: "10px 10px",
    backgroundColor: "#F8F9F9",
    margin: "10px 0px",
    width: "100%",
  },
  accordionsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  errorIcon: {
    position: "absolute",
    right: 10,
    fontSize: "20px",
  },
  ratingContainer: {
    display: "flex",
    columnGap: "5px",
    justifyContent: "center",
    "@media(max-width: 1000px)": {
      justifyContent: "start",
    },
  },
  downloadButton: {
    textTransform: 'none',
    width: 'min-content',
    padding: '0px',
    "@media(max-width: 1000px)": {
      width: "24px",
    },
  },
  downloadButtonLabel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'min-content'
  },
  downloadButtonText: {
     "@media(max-width: 1000px)": {
      width: "24px",
    },
  }
}));

const ResultAccordion = ({ uniqIndex, isDoctor, expanded, setExpanded }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [alarmRatingOpen, setAlarmRatingOpen] = useState(false);
  const { activePatient, listOfPatients, activePatientResults } = useSelector(
    (state) => state.patients
  );
  const [result, setResult] = useState(
    activePatientResults?.find((i) => i.idOrder === uniqIndex)
  );
  const { themeMaterialUI } = useSelector((store) => store.theme);
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const [feedBackRating, setFeedbackRating] = useState(null);
  const [isSick, setIsSick] = useState(false);
  const actualPatient = listOfPatients?.find(
    (pat) => pat.id === result.idClient
  );
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (feedBackRating === null && !result.integration) {
      getCanShowFeedback(result.idOrder).then((data) => {
        setFeedbackRating(data);
      });
    }
  }, [result, feedBackRating]);

  useEffect(() => {
    setResult(activePatientResults?.find((i) => i.idOrder === uniqIndex));
  }, [activePatientResults]);

  const handleGetOrdersById = async (result) => {
    let resultOrderId;
    if (result.integration) {
      // resultOrderId = await getOrdersResultByOrderIDIntegration(result.idOrder);
      resultOrderId = await getOrdersResultByOrderIDIntegrationRaw(result.idOrder);
    } else {
      resultOrderId = isDoctor
        ? await getOrdersResultForDoctor(result.idOrder, result.idClient).catch(
            (error) => error
          )
        : await getOrdersResultByOrderID(result.idOrder, result.idClient).catch(
            (error) => error
          );
    }

    if (!isDoctor)
      dispatch(
        setResultsByOrderId(
          resultOrderId instanceof Error ? null : resultOrderId,
          result.idOrder
        )
      );
  };

  const handlePanelChange = (panel, result) => async (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    if (newExpanded) {
      handleGetOrdersById(result);
    }
  };

//   const showRespondVisitDialog = (event, result, mark) => {
//     CustomDialog(
//       RespondVisitDialog,
//       {
//         result,
//         mark,
//       },
//       event,
//       themeMaterialUI
//     );
//   };

  const handleDownloadPDF = async (event, idOrder, idClient) => {
    setLoading(true);
    try {
      let res;
      if (result.integration) {
        res = await getResultsPdfIntegration(idOrder);
      } else {
        res = await getResults(idOrder, idClient);
      }

      const url = window.URL.createObjectURL(
        new Blob([res], { type: "application/pdf" })
      );

      const link = document.createElement("a");
      link.href = url;
      link.download = `${
        activePatient && activePatient.lastname && activePatient.lastname
      }_${
        activePatient && activePatient.firstname && activePatient.firstname
      }_${
        activePatient && activePatient.fathername && activePatient.fathername
      }.pdf`;
      link.click();
      link.remove();
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <CabinetAccordion
      key={result.idOrder}
      TransitionProps={{
        timeout: 0,
      }}
      expanded={expanded === result.idOrder}
      onChange={handlePanelChange(result.idOrder, result)}
      classes={{ root: classes.accordionRoot }}
      isSick={isSick}
    >
      <CabinetAccordionSummary
        expandIcon={<ExpandMoreIcon fontSize={"small"} color={"primary"} />}
        classes={{ content: classes.summaryContent }}
        isSick={result.isSick}
        key={uniqIndex}
      >
        {loading ? (
          <Loading />
        ) : (
          <Button
          color={result.ready > 0 ? "primary" : "disabled"}
                        style={mdUp ? {} : { position: "absolute", top: 0, right: -20, width: '24px' }}

            className={classes.downloadButton}
            classes={{label: classes.downloadButtonLabel, touchRipple: {root: classes.downloadButtonText}}}
            onClick={(e) => {
              e.stopPropagation();
              if (result.ready > 0 || result.integration)
                handleDownloadPDF(e, result.idOrder, result.idClient);
            }}
          >
            <DownloadIcon
              color={result.ready > 0 || result.integration ? "primary" : "disabled"}
              className={classes.downloadIcon}
              onClick={(e) => {
                e.stopPropagation();
                console.log("result", result);
                if (result.ready > 0 || result.integration)
                  handleDownloadPDF(e, result.idOrder, result.idClient);
              }}
            />
            {mdUp ? 'завантажити' : ''}
          </Button>
        )}

          <Typography
            className={classes.resultLabel}
            color={"textPrimary"}
            style={{
              ...(mdUp ? {} : { order: 0, flex: "1 0 40%" }),
              justifySelf: "flex-start",
              width: "100px",
              wordBreak: "break-word",
            }}
            component={"div"}
          >
            {result.num || result.idOrder}
          </Typography>
          <Typography
            className={classes.resultLabel}
            color={"textPrimary"}
            style={mdUp ? {} : { order: 0, flex: "1 0 40%" }}
            component={"div"}
          >
            {listOfPatients && actualPatient && (
              <span
                style={{
                  fontSize: "12px",
                  margin: "0px 4px",
                }}
              >
                {actualPatient?.lastname} {actualPatient?.firstname}{" "}
                {actualPatient?.fathername}
              </span>
            )}
            {!actualPatient && result.fullname && (
              <span
                style={{
                  fontSize: "12px",
                  margin: "0px 4px",
                }}
              >
                {result.fullname}
              </span>
            )}
          </Typography>
        <Typography
          className={classes.resultLabel}
          style={mdUp ? {} : { order: 1, flex: "1 0 60%", margin: "0px 4px" }}
          color={"textPrimary"}
          component={"div"}
        >
          {getDateLabelPattern(result.dt) +
            " " +
            result?.dt?.slice(10, result?.dt?.length)}
          <br />
          <Typography className={classes.columnLabel}>
            {/*{+result.ready === +result.total && result.ready > 0*/}
            {/* ? 'Результати готові'*/}
            {/* : +result.ready === 0*/}
            {/*  ? 'Результати в роботі'*/}
            {/*  : 'Результати частково готові'}*/}
          </Typography>
        </Typography>
        <Typography
          className={classes.resultLabel}
          style={mdUp ? {} : { order: 3, flex: "1 0 100%" }}
          color={"textPrimary"}
          component={"div"}
        >
          {result.address || result.reception_address || ""}
        </Typography>
        <div
          className={classes.ratingContainer}
          style={mdUp ? {} : { order: 4, flex: "1 0 100%" }}
        >
          {/* {!result.integration && (
            <AlarmTooltip
              text={
                "Ви не можете залишити відгук, оскільки термін його опрацювання закінчився (30 днів)"
              }
              heading={"УВАГА!"}
              open={alarmRatingOpen}
              onClose={() => setAlarmRatingOpen(false)}
            >
              <Rating
                value={feedBackRating}
                name={"rating"}
                onChange={(e, value) => {
                  if (result.ready) {
                    if (value !== null) {
                      showRespondVisitDialog(e, result, value);
                    }
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!result.ready) {
                    setAlarmRatingOpen(true);
                  }
                }}
                classes={{
                  iconHover: classes.rateIconHover,
                  iconFilled: classes.rateIconFilled,
                }}
                emptyIcon={
                  <StarBorderIcon color={"primary"} fontSize={"small"} />
                }
                icon={<StarIcon color={"primary"} fontSize={"small"} />}
              />
            </AlarmTooltip>
          )} */}
        </div>
      </CabinetAccordionSummary>
      <CabinetAccordionDetails className={classes.detailsContainer}>
        {result.integration 
        ? result.results ? <div /> : (<Loading />)
        : <>
          {result?.results ? (
            <>
              {result.results.length > 0 &&
                result.results
                  .reduce((acu, cur) => {
                    const similarAssay = acu.find(
                      (item) => cur.complex ? item.complex === cur.complex : item.idOrdertest === cur.idOrdertest
                    );

                    if (similarAssay) {
                      return [
                        ...acu.filter((item) => similarAssay.complex ? item.complex !== similarAssay.complex : item.idOrdertest !== similarAssay.idOrdertest),
                        {
                          ...result,
                          ...similarAssay,
                          results: [...similarAssay.results, cur],
                        },
                      ];
                    }
                      
                    return [...acu, { ...cur, results: [cur] }];
                  }, [])
                  .map((grRs, idxOfGrRes) => {
                    // console.log(grRs);
                    const groupedResult = {
                      ...grRs,
                      results: grRs?.results?.sort(
                        (a, b) => +a.order - +b.order
                      ),
                    };

                    return (
                      <React.Fragment
                        key={"result" + idxOfGrRes + groupedResult.id}
                      >
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "0px 10px",
                            }}
                          >
                            <Typography className={classes.columnLabel}>
                              Показник
                            </Typography>
                            <Typography className={classes.columnLabel}>
                              {/*{groupedResult.results.filter(i => +i.integration ? i.result : +i?.ready !== 0).length > 0 ? 'Результат готовий' : 'Результати ще не готові'}*/}
                            </Typography>
                          </div>
                          <div className={classes.researchDescription}>
                            <Typography
                              style={
                                mdUp ? { flex: "3 1 0" } : { flex: "2 1 0" }
                              }
                              className={classes.resultLabel}
                              color={"textPrimary"}
                            >
                              {groupedResult.complex 
                              ? groupedResult.complex
                              : groupedResult.packet &&
                              Array.isArray(groupedResult.packet)
                                ? groupedResult.packet[1]
                                : groupedResult.packet}
                            </Typography>
                            <Typography
                              style={
                                mdUp
                                  ? { flex: "1 1 0", fontWeight: 400}
                                  : { flex: "2 1 0", textAlign: "end", fontWeight: 400 }
                              }
                              className={classes.resultLabel}
                              color={"textPrimary"}
                              component={"div"}
                            >
                              {groupedResult.results &&
                                groupedResult.results.length > 0 &&
                                getDateLabelPattern(
                                  groupedResult.results[0].utime
                                ) +
                                  " " +
                                  groupedResult.results[0].utime.slice(10, 19)}
                            </Typography>
                          </div>
                        </div>
                        {groupedResult.results.filter((i) => +i?.ready > 0)
                          .length > 0 ||
                          (result.integration && (
                            <Grid container style={{ padding: "0px 10px" }}>
                              <Grid item xs={4}>
                                <Typography className={classes.columnLabel}>
                                  Параметр
                                </Typography>
                              </Grid>
                              <Grid item xs={mdUp ? 4 : 3}>
                                <Typography
                                  className={classes.columnLabel}
                                  style={{ marginLeft: "30px" }}
                                >
                                  Значення
                                </Typography>
                              </Grid>
                              <Grid item xs={mdUp ? 4 : 5}>
                                <Typography className={classes.columnLabel}>
                                  Референтні значення
                                </Typography>
                              </Grid>
                            </Grid>
                          ))}
                        {groupedResult.results
                          .filter((i) =>
                            groupedResult.integration
                              ? i.result
                              : +i?.ready !== 0
                          )
                          .reduce((acu, cur) => {
                            const similarAssay = acu.find(
                              (item) =>
                                item.groupId &&
                                cur.groupId &&
                                item.groupId === cur.groupId
                            );
                            if (similarAssay) {
                              return [
                                ...acu.filter(
                                  (item) =>
                                    item.groupId !== similarAssay.groupId
                                ),
                                {
                                  ...result,
                                  ...similarAssay,
                                  groupedResults: [
                                    ...(similarAssay.groupedResults || []),
                                    cur,
                                  ],
                                },
                              ];
                            }

                            return [
                              ...acu,
                              {
                                ...cur,
                                groupedResults: [
                                  ...(cur.groupedResults || []),
                                  cur,
                                ],
                              },
                            ];
                          }, [])
                          .map((research, idx) => {
                            const Result = ({ research }) => (
                              <>
                                <Grid
                                  key={
                                    research.integration
                                      ? research.id
                                      : research.idtest + " " + idx
                                  }
                                  container
                                  style={{
                                    backgroundColor:
                                      research.state === "normal" ||
                                      (result.integration &&
                                        !research.outOfNorm)
                                        ? "#F8F9F9"
                                        : "#ffcfcf",
                                    padding: "10px",
                                    position: "relative",
                                  }}
                                >
                                  <Grid item xs={4}>
                                    <Typography
                                      className={classes.researchLabel}
                                      color={"textPrimary"}
                                    >
                                      {research.test}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={mdUp ? 4 : 3}>
                                    <Typography
                                      className={classes.researchLabel}
                                      color={
                                        research.isSick
                                          ? "error"
                                          : "textPrimary"
                                      }
                                      component={"div"}
                                      style={{ marginLeft: "8px" }}
                                    >
                                      {research.outOfNorm ? (
                                        <strong>{research.result + " "}</strong>
                                      ) : (
                                        <span>{research.result + " "}</span>
                                      )}
                                      {research.units &&
                                        research.units !== "-" && (
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: research.units,
                                            }}
                                          />
                                        )}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={mdUp ? 4 : 5}>
                                    <Typography
                                      className={classes.researchLabelNorm}
                                      color={"textPrimary"}
                                    >
                                      {research.norm &&
                                        research.norm !== "{NULL}" &&
                                        research.norm
                                          .split('"')
                                          .join("")
                                          .split("#%")
                                          .join("")
                                          .split("{")
                                          .join("")
                                          .split("}")
                                          .map((norm, idx) => {
                                            if (norm.length !== 0) {
                                              return (
                                                <Fragment key={idx}>
                                                  {norm.indexOf(",") === 0 ? (
                                                    <span
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          norm.slice(1) + " ",
                                                      }}
                                                    />
                                                  ) : (
                                                    <span
                                                      dangerouslySetInnerHTML={{
                                                        __html: norm + " ",
                                                      }}
                                                    />
                                                  )}
                                                  {(research.units &&
                                                    research.units) !== "-" && (
                                                    <span
                                                      dangerouslySetInnerHTML={{
                                                        __html: research.units,
                                                      }}
                                                    />
                                                  )}
                                                </Fragment>
                                              );
                                            } else return null;
                                          })}
                                    </Typography>
                                  </Grid>
                                  {research.state &&
                                    research.state !== "normal" &&
                                    !groupedResult.integration && (
                                      <ErrorIcon
                                        color={"error"}
                                        className={classes.errorIcon}
                                      />
                                    )}
                                </Grid>
                                {research.subResults &&
                                  research.subResults.map((subResult, idx) => {
                                    return (
                                      <Grid
                                        key={subResult.id + idx}
                                        container
                                        style={{
                                          backgroundColor: result.integration
                                            ? "#F8F9F9"
                                            : "#FFEAEA",
                                          padding: "10px",
                                          position: "relative",
                                          paddingTop: "12px",
                                        }}
                                      >
                                        <Grid item xs={4}>
                                          <Typography
                                            className={classes.researchLabel}
                                            color={"textPrimary"}
                                          >
                                            {subResult.name}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={mdUp ? 4 : 3}>
                                          <Typography
                                            className={classes.researchLabel}
                                            color={"textPrimary"}
                                            component={"div"}
                                            style={{ marginLeft: "30px" }}
                                          >
                                            {subResult.result}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    );
                                  })}
                                {research.description && (
                                  <Grid
                                    container
                                    style={{
                                      backgroundColor: result.integration
                                        ? "#F8F9F9"
                                        : "#FFEAEA",
                                      padding: "10px",
                                      position: "relative",
                                    }}
                                  >
                                    <Typography
                                      className={classes.researchLabel}
                                      style={{ fontStyle: "italic" }}
                                      color={"textPrimary"}
                                    >
                                      Коментар: {research.description}
                                    </Typography>
                                  </Grid>
                                )}
                              </>
                            );

                            return research.resulttype === "json" ? (
                              <ResultJSON assay={research} key={research.id} />
                            ) : research.groupedResults ? (
                              <Fragment key={idx + research.id}>
                                {research.groupName && (
                                  <Grid
                                    container
                                    style={{
                                      backgroundColor: result.integration
                                        ? "#F8F9F9"
                                        : "#FFEAEA",
                                      padding: "10px",
                                      position: "relative",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.researchLabel}
                                      style={{
                                        fontStyle: "italic",
                                        textAlign: "center",
                                      }}
                                      color={"textPrimary"}
                                    >
                                      {research.groupName}
                                    </Typography>
                                  </Grid>
                                )}
                                {research.groupedResults.map(
                                  (groupedResult, idx) => (
                                    <Result
                                      research={groupedResult}
                                      key={idx + groupedResult.groupId}
                                    />
                                  )
                                )}
                              </Fragment>
                            ) : (
                              <Result research={research} />
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
            </>
          ) : result?.results === null ? (
            <p style={{ color: "red" }}>
              Вибачте, неможливо відобразити результати.
            </p>
          ) : (
            <Loading />
          )}
        </>}
      </CabinetAccordionDetails>
    </CabinetAccordion>
  );
};

export default ResultAccordion;
